import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useLocation, useHistory} from 'react-router-dom';
import * as S from './TermsCondition.styles';
import * as C from '../../Common.styles';
import {validations} from '../../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';
import {
  AGREEMENT_PAGE_URL,
  TERMS_CONDITIONS_PAGE_URL,
  ACCOUNT_MANUAL_PAGE_URL,
  ACCOUNT_CREATED_PAGE_URL,
} from '../../../../../constants/index';
import {
  getTerms,
  termsPageRequest,
  agreementAcceptanceRequest,
} from '../../../../../store/actions/thunk';
import ButtonLoader from '../../../UI/Loader/Loader';
import IconSelector from '@ibibo/icon-selector';
import {
  tokenSelector,
  agencyNameSelector,
  fullnameSelector,
  addressSelector,
  gstNumberSelector,
  panNumberSelector,
  emailSelector,
  mobileSelector,
  verify_mmt_passwordSelector,
  account_existsSelector,
  account_existsMessageSelector,
} from '../../../../../store/selectors';

import {getCrid} from '../../../../../../../myaccount/src/utils/redirectWithCrId';

const TermsCondition = ({apiError, mobileUser, setPassword, setLoader, agreement_type}) => {
  const dispatch = useDispatch();

  const history = useHistory();

  const [userAgree, setUserAgree] = useState('');
  const [userConsent, setUserConsent] = useState('');
  const [userAgreed, setUserAgreed] = useState(false);
  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [loadTerms, setLoadTerms] = useState(true);
  const location = useLocation();

  const token = useSelector(tokenSelector);
  const agency_name = useSelector(agencyNameSelector);
  const agent_name = useSelector(fullnameSelector);
  const address = useSelector(addressSelector);
  const gstin = useSelector(gstNumberSelector);
  const pan_details = useSelector(panNumberSelector);
  const email = useSelector(emailSelector);
  const mobile = useSelector(mobileSelector);

  const [pageLoad, setPageLoad] = useState(setLoader);

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  const fieldValidators = {
    tncChecked: {field: 'password', fieldName: 'terms and conditions', validators: ['mustRead']},
  };

  const validateField = (field, dataObj) => {
    const errorObj = {...errors};
    if (fieldValidators[field]) {
      errorObj[field] = '';
      const validators = fieldValidators[field].validators;
      for (let i = 0; i < validators.length; i++) {
        const validateFunction = validations[validators[i]];
        const validateDataObj = {
          value: dataObj[field],
          fieldName: fieldValidators[field].fieldName,
        };
        const resp = validateFunction(validateDataObj);
        if (resp && !errorObj[field]) {
          errorObj[field] = resp;
        }
      }
    }
    setError(errorObj);
  };

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const validateDataObj = {
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
          };
          const resp = validateFunction(validateDataObj);
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const dataTerms = {
    token,
    agency_name,
    agent_name,
    address,
    gstin,
    pan_details,
    email,
    mobile,
  };

  const successCallback = data => {
    setUserAgree(data);
    setPageLoad(false);
    setLoadTerms(false);
  };

  const errorCallback = () => {
    setPageLoad(false);
  };

  useEffect(() => {
    if (mobileUser && !userAgreed) {
      let fd = new FormData();
      for (const key in dataTerms) {
        fd.append(key, dataTerms[key]);
      }
      //dispatch(getTerms(fd, successCallback, errorCallback));
      dispatch(termsPageRequest(token, successCallback, errorCallback));
      setPageLoad(true);
    }
  }, [mobileUser]);

  const setTnCAgree = (event: React.FormEvent) => {
    sendEvarData(
      {
        prop54: 'myPatner|signup|setPassword|getStarted',
      },
      true,
    );
    event.preventDefault();
    let newDate = new Date().getTime();
    setUserConsent(newDate);
    dispatch(
      agreementAcceptanceRequest(
        {token, userConsent},
        successCallbackForAcceptance,
        successCallbackForAcceptance,
      ),
    );
  };

  const agreeEvent = () => {
    sendEvarData(
      {
        prop54: 'myPatner|signup|setPassword|tnc|checked',
      },
      true,
    );
    setUserAgreed(userAgreed => !userAgreed);
    let newDate = new Date().getTime();
    setUserConsent(newDate);
  };

  const successCallbackForAcceptance = screen => {
    if (screen === 'verification') {
      history.push(`${ACCOUNT_CREATED_PAGE_URL}?crId=${getCrid()}`);
    } else if (screen === 'manual') {
      history.push(`${ACCOUNT_MANUAL_PAGE_URL}?crId=${getCrid()}`);
    }
  };

  return (
    <C.PopContentMainWrap>
      {/* <C.PopContentHeadWrap>
            <C.PopContentHeadText>Create a Password for your account</C.PopContentHeadText>
            <C.PopContentSubHeadText>You can use this password to login, if OTP is not acccessible.</C.PopContentSubHeadText>
        </C.PopContentHeadWrap> */}
      <C.PopContentInnerWrap>
        {loadTerms ? (
          <S.PageLoaderWrap>
            <IconSelector iconKey="linearloader" props={{top: '50%', width: '20rem'}} />
          </S.PageLoaderWrap>
        ) : (
          <C.UserInfoForm onSubmit={setTnCAgree}>
            <S.TnCWrapper dangerouslySetInnerHTML={{__html: userAgree?.data}}></S.TnCWrapper>

            <S.UserActionWrapper>
              <S.UserImportantInfoWrap>
                <S.UserConsentText HTMLfor="terms" onClick={agreeEvent}>
                  <S.UserTermsCheck id="terms" checked={userAgreed}></S.UserTermsCheck>
                  <span>I agree to all the Terms & Conditions</span>
                </S.UserConsentText>
                <C.ErrorText>{errors['tncChecked']}</C.ErrorText>
              </S.UserImportantInfoWrap>
              <C.ButtonWrap>
                <C.ContinueButton type="submit" disabled={!userAgreed || setLoader}>
                  {pageLoad ? <ButtonLoader loaderType="button" /> : 'Create Account'}
                </C.ContinueButton>
              </C.ButtonWrap>
            </S.UserActionWrapper>
          </C.UserInfoForm>
        )}
      </C.PopContentInnerWrap>
    </C.PopContentMainWrap>
  );
};

export default TermsCondition;
